__turbopack_context__.v({
  "header_container": "styles-module-scss-module__sfggpq__header_container",
});
